import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { showNotification, CREATE } from 'react-admin';
import { push } from 'react-router-redux';
import dataProviderFactory from '../dataProvider'
import styled from 'styled-components'

const StyledButton = styled(Button)`
    color: black !important;
`

class NoBikeAvailableButton extends Component {
    handleClick = async () => {
        const dataProvider = await dataProviderFactory('rest')
        const { push, record, showNotification } = this.props;
        const updatedRecord = { ...record, is_approved: true };
        dataProvider(CREATE, `rentals/no_bike/${record.id}`, { id: record.id, data: updatedRecord })
            .then(() => {
                showNotification('Request Processed');
                push('/pending_rentals');
            })
            .catch((e) => {
                showNotification('Error: Request not processed', 'warning')
            });
    }
    render() {
        return <StyledButton onClick={this.handleClick}> No Bike Available </StyledButton>;
    }
}

NoBikeAvailableButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification,
    push,
})(NoBikeAvailableButton);



// WEBPACK FOOTER //
// ./src/components/noBikeAvailableButton.js